<template>
  <div class="page">
    <div class="layout">
      <el-row>
        <el-col :span="24">
          <div class="page-title">個人資料</div>
        </el-col>
      </el-row>
      <div class="page-box">
        <personal-information-form
          ref="form"
          :form="form"
        ></personal-information-form>
        <div>請註意：標有 (*) 的為必填項。</div>
        <el-button type="info" class="submitButton" @click="onSubmit"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getUserDetail, putUser } from "@/api/users";
import PersonalInformationForm from "./components/personalInformationForm.vue";
export default {
  components: { PersonalInformationForm },
  data() {
    return {
      form: {
        userNo: null,
        name: null,
        gender: null,
        email: null,
        password: null,
        confirmPassword:null,
        phone: null,
        roleId: null,
      },
    };
  },
  created() {
    this.getUserDetail();
  },
  methods: {
    onSubmit() {
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
          // 提交表单
          this.putUser();
        }
      });
    },
    getUserDetail() {
      getUserDetail(this.$store.getters.adminUserInfo.userId).then((v) => {
        this.form = v.data;
        //字符串深拷贝
        let aaa = v.data.password
        this.form.confirmPassword =  aaa
      
      });
    },
    putUser() {
      putUser(this.$store.getters.adminUserInfo.userId, this.form).then(() => {
        this.$message.success("修改成功");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }
  }
}
.submitButton {
  width: 150px;
  margin-top: 20px;
}
.page-box {
  background-color: #fff;
  padding: 20px;
}
</style>